import arrow from 'assets/svg/arrow.svg';
import calendar from 'assets/svg/calendar.svg';
import cancel from 'assets/svg/cancel.svg';
import caution from 'assets/svg/caution.svg';
import download from 'assets/svg/download.svg';
import eyeOff from 'assets/svg/eyeOff.svg';
import eyeOn from 'assets/svg/eyeOn.svg';
import file from 'assets/svg/file.svg';
import flag from 'assets/svg/flag.svg';
import folder from 'assets/svg/folder.svg';
import lock from 'assets/svg/lock.svg';
import man from 'assets/svg/man.svg';
import passport from 'assets/svg/passport.svg';
import search from 'assets/svg/search.svg';
import selfie from 'assets/svg/selfie.svg';
import help from 'assets/svg/help.svg';
import nonResidenceCardIDs from 'assets/svg/nonResidenceCardIDs.svg';

export enum IconName {
  arrow,
  calendar,
  cancel,
  caution,
  download,
  eyeOff,
  eyeOn,
  file,
  flag,
  folder,
  lock,
  man,
  passport,
  nonResidenceCardIDs,
  search,
  selfie,
  help,
}

type Icon = { id: IconName; icon: string };
const Icons: Icon[] = [
  { id: IconName.arrow, icon: arrow },
  { id: IconName.calendar, icon: calendar },
  { id: IconName.cancel, icon: cancel },
  { id: IconName.caution, icon: caution },
  { id: IconName.download, icon: download },
  { id: IconName.eyeOff, icon: eyeOff },
  { id: IconName.eyeOn, icon: eyeOn },
  { id: IconName.file, icon: file },
  { id: IconName.flag, icon: flag },
  { id: IconName.folder, icon: folder },
  { id: IconName.lock, icon: lock },
  { id: IconName.man, icon: man },
  { id: IconName.passport, icon: passport },
  { id: IconName.nonResidenceCardIDs, icon: nonResidenceCardIDs },
  { id: IconName.search, icon: search },
  { id: IconName.selfie, icon: selfie },
  { id: IconName.help, icon: help },
];

export const findIcon = (name: IconName) => {
  return Icons.find((icon) => icon.id === name)?.icon || '';
};
